<template>
    <div style="background-color: #ffffff;">
        <div style="font-size: 18px; text-align: center; padding: 20px;">{{activityDetail.name}}</div>
        <van-cell-group>
            <van-cell title="活动类型" :value="$store.state.systemEnum['company']['activity']['type'][activityDetail.type]"></van-cell>
            <van-cell title="活动时间">
                <template #label>
                    <span style="font-size: 14px;">{{activityDetail.start_time}} ~ {{activityDetail.end_time}}</span>
                </template>
            </van-cell>
            <van-cell title="说明" v-if="activityDetail.explain">
                <template #label>
                    <span style="font-size: 14px;">{{activityDetail.explain}}</span>
                </template>
            </van-cell>
        </van-cell-group>
    </div>
</template>

<script>
    import wx from 'weixin-js-sdk';
    import api from "../../assets/js/api";

    export default {
        name: "Detail",
        data(){
            return {
                activityDetail : {},
            };
        },
        created() {
            let self = this;
            api.request('/activity/detail', {
                'id' : this.$route.query.id,
            }).then(res => {
                self.activityDetail = res.data;
                if (res.data.type === 'lottery') {
                    self.$router.replace({
                        name : 'SpinLottery',
                        query : {
                            id: self.$route.query.id
                        },
                    })
                }
            })
        },
    }
</script>

<style scoped>
    .title{
        padding: 15px 0 20px 15px;
        font-size: 20px;
        background-color: #ffffff;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/pages/activity/Detail.vue